// extracted by mini-css-extract-plugin
module.exports = {"text":"styles_text__qS6qm","chevron":"styles_chevron__2f47A","skeleton-animation":"styles_skeleton-animation__Pe6jd","container":"styles_container__bNFt3"};